function ExhibitLabel({ fear }) {
  const items = [
    ["Category", fear.category],
    ["Intensity", `${fear.intensity}/10`],
    ["Common trigger", fear.commonTrigger],
    ["Core question", fear.coreQuestion]
  ];

  return (
    <dl className="grid gap-3 rounded-lg border border-museum-gold/25 bg-museum-black/45 p-5 sm:grid-cols-2">
      {items.map(([label, value]) => (
        <div key={label} className="border-b border-museum-bone/10 pb-3 last:border-b-0 sm:last:border-b">
          <dt className="text-xs uppercase tracking-[0.24em] text-museum-gold/85">{label}</dt>
          <dd className="mt-2 text-sm leading-6 text-museum-bone">{value}</dd>
        </div>
      ))}
    </dl>
  );
}

export default ExhibitLabel;
